import moment from 'moment';

export function getDateObject(stringDate) {
  let date = new Date(stringDate);
  return stringDate !== null && stringDate !== '' && date instanceof Date && !isNaN(date) ? date : null;
}

export function getDateObjectFromDate(date) {
  if (typeof date === 'string') {
    date = getDateObject(date);
  } else if (moment.isMoment(date)) {
    date = date.toDate();
  }
  date = new Date(date);
  return date instanceof Date && !isNaN(date) ? date : null;
}

export function addMonths(date, months, limitDateTime) {
  if (date === null) {
    return null;
  }
  let newDate = resetDayTime(new Date(date), true);
  newDate.setMonth(newDate.getMonth() + (months || 1));
  if (months > 0) {
    newDate = limitDateTime && newDate > limitDateTime ? limitDateTime : newDate;
  } else {
    newDate = limitDateTime && newDate < limitDateTime ? limitDateTime : newDate;
  }
  return newDate;
}

const billingCycleMonths = {
  monthly: 1,
  quarterly: 3,
  annual: 12,
};

export function getPeriodStartEnd(period_start, period_end, billing_cycle, startDate) {
  let subscriptionStartDateTime = getDateObject(period_start);
  let subscriptionEndDateTime = getDateObject(period_end);
  startDate = getDateObjectFromDate(startDate) || new Date();
  let startDateTime =
    subscriptionStartDateTime && subscriptionStartDateTime >= startDate ? subscriptionStartDateTime : startDate;
  let endDateTime = resetDayTime(new Date(startDateTime), true);
  console.log('billing_cycle', billing_cycle);
  endDateTime = addMonths(endDateTime, billingCycleMonths[billing_cycle] || 1);

  if (subscriptionEndDateTime && subscriptionEndDateTime <= endDateTime) {
    endDateTime = subscriptionEndDateTime;
  }

  return { startDate: startDateTime, endDate: endDateTime };
}

export function resetDayTime(date, alsoDate = false) {
  date = new Date(date);
  date.setHours(0, 0, 0, 0);
  if (alsoDate) {
    date.setDate(1);
  }
  return date;
}

export function getAvailableDateRange(
         subscriptionId,
         subscriptionsList,
         isStartDate = true,
         startDate,
         endDate,
         subscription,
         cancelAtPeriodEnd = false
       ) {
         subscription = subscription ?? subscriptionsList?.data?.list?.find(({ id }) => id === subscriptionId);

         let startDateTime = getDateObjectFromDate(startDate) || new Date();
         let endDateTime = getDateObjectFromDate(endDate) || addMonths(startDateTime, 1);
         let currentDate = resetDayTime(new Date());

         if (!subscription) {
           return isStartDate
             ? {
                 minDate: currentDate,
                 maxDate: cancelAtPeriodEnd ? endDateTime : null,
               }
             : { minDate: addMonths(startDateTime), maxDate: null };
         }

         const { period_start, period_end } = subscription;
         const subscriptionStartDateTime = getDateObject(period_start);
         const subscriptionEndDateTime = getDateObject(period_end);
         startDateTime =
           subscriptionStartDateTime && subscriptionStartDateTime >= startDateTime
             ? subscriptionStartDateTime
             : startDateTime;
         endDateTime =
           subscriptionEndDateTime && subscriptionEndDateTime <= endDateTime ? subscriptionEndDateTime : endDateTime;
         const startDateTimeOneMonthLater = addMonths(startDateTime);

         if (isStartDate) {
           return {
             minDate:
               subscriptionStartDateTime && subscriptionStartDateTime >= currentDate
                 ? subscriptionStartDateTime
                 : currentDate,
             maxDate: cancelAtPeriodEnd ? endDateTime : subscriptionEndDateTime,
           };
         } else {
           return {
             minDate:
               subscriptionEndDateTime && startDateTimeOneMonthLater > subscriptionEndDateTime
                 ? subscriptionEndDateTime
                 : startDateTimeOneMonthLater,
             maxDate: subscriptionEndDateTime,
           };
         }
       }
